export var KnowledgeEntryKind;
(function (KnowledgeEntryKind) {
    KnowledgeEntryKind["Playbook"] = "playbook";
    KnowledgeEntryKind["PostmortemFinding"] = "postmortem_finding";
    KnowledgeEntryKind["StatusReportSection"] = "status_report_section";
    KnowledgeEntryKind["ClosedDeal"] = "closed_deal";
    KnowledgeEntryKind["Lesson"] = "lesson";
})(KnowledgeEntryKind || (KnowledgeEntryKind = {}));
/**
 * Verdict the judge agent assigns to a single commitment after consulting
 * playbooks + knowledge files. The four kinds differ on what kind of evidence
 * was available:
 *
 * - `Contradiction` — head-on factual collision. The prompt or a knowledge
 *   file contains BOTH sides of the conflict as literal facts (e.g. the
 *   commitment says "deliver by 2024-09-01" and the contract file says
 *   "contracted delivery 2024-12-01"). Demonstrable; fix-the-paperwork.
 * - `Risk` — a playbook's predicate is satisfied by facts in evidence, but
 *   no rival fact directly contradicts the commitment (e.g. commitment says
 *   "HA failover on Nokia DWDM" + playbook says "Nokia HA on cheap SKUs is
 *   manual only" + SKU list matches). Predictive, not literal-conflict.
 * - `Assumption` — a playbook is on point but a fact its predicate needs is
 *   missing. The verdict is phrased conditionally ("if the contracted-end
 *   date is less than …"). Used instead of inventing the missing fact.
 * - `Clean` — no playbook or knowledge says anything relevant. The default.
 *
 * `Contradiction` is the only kind that requires both sides of the conflict
 * to be present as literal facts; if one side is missing, the correct kind
 * is `Assumption` or `Risk`. This guardrail is what stops the model from
 * hallucinating conflicts.
 */
export var VerdictKind;
(function (VerdictKind) {
    VerdictKind["Contradiction"] = "contradiction";
    VerdictKind["Risk"] = "risk";
    VerdictKind["Assumption"] = "assumption";
    VerdictKind["Clean"] = "clean";
})(VerdictKind || (VerdictKind = {}));
